import React, { useState, useEffect } from 'react';
import ShoppingCartSummary from './ShoppingCartSummary';
import './Verkoop.css';
import Background from './shopping-cart.jpg';

function Verkoop() {
  const [cart, setCart] = useState([]);
  const [total, setTotal] = useState(0);

  const items = [
    { id: 1, name: 'Mattentaart', price: 5 }
  ];

  const addMattentaart = () => {
    if (cart.length == 0) {
      setCart([{ ...items[0], quantity: parseInt(document.getElementById("aantalmattentaarten").value) }]);    
    } else {
      setCart(
        cart.map((cartItem) => ({ ...cartItem, quantity: cartItem.quantity + parseInt(document.getElementById("aantalmattentaarten").value) })
        )
      );
    }
    setTotal(total + (items[0].price * document.getElementById("aantalmattentaarten").value));
    document.getElementById("aantalmattentaarten").value = 1;
  };

  return (
    <div className="Verkoop">
      <h1>Verkoop</h1>
      <div id="verkoopkaart">
        <img src={require('./mattentaarten.jpg')} />
        <div>
          <h2>Mattentaarten</h2>
          <p>In 1 zakje zitten 2 mattentaarten. De kostprijs is €5/zakje. Mattentaarten zijn af te halen op zaterdag 21 november.</p>
          <p>Aantal zakjes:</p>
          <input id="aantalmattentaarten" type="number" defaultValue="1"></input><button onClick={() => addMattentaart()}>Toevoegen aan winkelwagen</button>
        </div>
      </div>    

      <ShoppingCartSummary cart={cart} setCart={setCart} total={total} setTotal={setTotal}/>
    </div>
  );
}

export default Verkoop;
